import { render, staticRenderFns } from "./ChildPage.vue?vue&type=template&id=d34e665a&"
import script from "./ChildPage.vue?vue&type=script&lang=js&"
export * from "./ChildPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports